import groq from 'groq';
import {
  IconStackComponentResolver,
  AccordionComponentResolver,
  TextComponentResolver,
  ImageComponentResolver,
  VideoComponentResolver,
  MediaComponentResolver,
  QuoteComponentResolver,
  CarouselComponentResolver
} from '../resolvers/components';
import { EntityType } from '$lib/sanity/types';
import { PosterFragment, TextComponentFragment } from '../components';
import { TagsFragment } from '../components/tags';
import { createGridWithGridItemId } from '../resolvers/utils';
import { CardContentLiteFragment } from '../components/cardContent';

export const NewsComponentSet = groq`
    ${TextComponentResolver},
    ${ImageComponentResolver},
    ${VideoComponentResolver},
    ${MediaComponentResolver},
    ${QuoteComponentResolver},
    ${CarouselComponentResolver},
    ${IconStackComponentResolver},
    ${AccordionComponentResolver}
`;

export const NewsPostGridLayout = createGridWithGridItemId(NewsComponentSet);

export const GetNewsPost = groq`*[(_type == "${EntityType.NewsPost}" || _type == "${EntityType.NewsBasicPost}") && slug.current == $slug]{
  ...,
  ${NewsPostGridLayout},
  ${TextComponentFragment},
  ${PosterFragment},
  ${TagsFragment},
  ${CardContentLiteFragment}
}[0]`;

export const GetNewsPostById = groq`
  *[(_type == "${EntityType.NewsPost}" || _type == "${EntityType.NewsBasicPost}") && _id == $id]{
    ...,
    ${NewsPostGridLayout},
    ${TextComponentFragment},
    ${PosterFragment},
    ${TagsFragment},
    ${CardContentLiteFragment}
  }[0]
`;

export const GetNewsPostsByTagQuery = groq`
  *[(_type == "${EntityType.NewsPost}" || _type == "${EntityType.NewsBasicPost}") && $id in tags[]._ref]{
    ...,
    ${TagsFragment},
    ${PosterFragment},
    ${CardContentLiteFragment},
    "sortDate": coalesce(publicationInfo.publicationDate, _updatedAt)
  } | order(sortDate desc, _id desc)
`;

export const GetNewsPostsByBrandQuery = groq`
  *[(_type == "${EntityType.NewsPost}" || _type == "${EntityType.NewsBasicPost}") && ($brand in brands)]{
    ...,
    "sortDate": coalesce(publicationInfo.publicationDate, _updatedAt),
    ${PosterFragment},
    ${CardContentLiteFragment}
  } | order(sortDate desc, _id desc)
`;

export const GetLatestPostsQuery = groq`
  *[_type == "${EntityType.NewsPost}" && tags[0]._ref in $tags && !(_id in $ids)]{
    ...,
    ${PosterFragment},
    ${CardContentLiteFragment},
    "sortDate": coalesce(publicationInfo.publicationDate, _updatedAt),
    ${TagsFragment}
  } | order(sortDate desc, _id desc)[0...$limit]
`;
